import { ChevronRight } from 'lucide-react'
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select'
import { PresetKey } from '../types'

const TRIGGER_STYLE = { backgroundColor: '#F5F5F5', padding: '6px 8px 6px 8px' }

interface PresetSelectProps {
  value: string | undefined
  displayLabel: string
  onValueChange: (_value: string) => void
}

const PRESET_OPTIONS: { value: PresetKey; label: string }[] = [
  { value: 'today', label: 'Hoje' },
  { value: 'lastWeek', label: 'Semana passada' },
  { value: 'lastMonth', label: 'Mês passado' },
]

export function PresetSelect({ value, displayLabel, onValueChange }: PresetSelectProps) {
  return (
    <div className="p-3">
      <Select value={value ?? undefined} onValueChange={onValueChange}>
        <SelectTrigger
          className="w-full border-0 [&>svg:not(.custom-chevron)]:hidden"
          style={TRIGGER_STYLE}
        >
          <div className="flex items-center justify-between w-full">
            <span className="text-sm">{displayLabel}</span>
            <ChevronRight className="h-4 w-4 opacity-50 flex-shrink-0 custom-chevron ml-4" />
          </div>
        </SelectTrigger>
        <SelectContent>
          {PRESET_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
